import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import brixigoLogo from "../assets/images/brixigo_logoo.png";
import { MARKETING_ROUTES } from "./routes";
import "./marketing.css";

const NAV_ITEMS = [
  { label: "Home", to: MARKETING_ROUTES.home, end: true },
  { label: "Features", to: MARKETING_ROUTES.features },
  { label: "Pricing", to: MARKETING_ROUTES.pricing },
  { label: "About Us", to: MARKETING_ROUTES.about },
  { label: "Contact Us", to: MARKETING_ROUTES.contact },
];

export default function MarketingNavbar({ onLoginClick, onBookDemoClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 4);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleLogin = () => {
    if (onLoginClick) onLoginClick();
    else navigate(MARKETING_ROUTES.login);
  };

  // Sign Up goes straight to "Create Your Workspace" (not the login popup)
  const handleSignUp = () => {
    navigate(MARKETING_ROUTES.register);
  };

  const handleDemo = () => {
    if (onBookDemoClick) onBookDemoClick();
    else navigate(MARKETING_ROUTES.demo);
  };

  const handleFeatures = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      const el = document.getElementById("feat-sec");
      if (el) window.scrollTo({ top: el.offsetTop - 76, behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  return (
    <nav className={`zn-nav mk-nav${scrolled ? " scrolled" : ""}`}>
      <div className="zn-nav-inner">
        <Link to={MARKETING_ROUTES.home} className="mk-nav-logo" aria-label="Brixigo home">
          <img src={brixigoLogo} alt="Brixigo" />
        </Link>

        <div className="zn-links">
          {NAV_ITEMS.map((item) =>
            item.to.includes("#") ? (
              <Link key={item.label} to={item.to} className="zn-link" onClick={handleFeatures}>
                {item.label}
              </Link>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `zn-link${isActive ? " is-active" : ""}`}
                onClick={() => {
                  if (item.to === MARKETING_ROUTES.home && location.pathname === "/") {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                {item.label}
              </NavLink>
            )
          )}
        </div>

        <div className="zn-actions">
          <button type="button" className="zn-btn-login" onClick={handleLogin}>Login</button>
          <button type="button" className="zn-btn-signup" onClick={handleSignUp}>Sign Up</button>
          <button type="button" className="zn-btn-demo" onClick={handleDemo}>
            Book a Demo
          </button>
          <button
            type="button"
            className="mk-nav-burger"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="mk-nav-drawer" role="dialog" aria-label="Site menu">
          {NAV_ITEMS.map((item) =>
            item.to.includes("#") ? (
              <Link key={item.label} to={item.to} className="mk-nav-drawer-link" onClick={handleFeatures}>
                {item.label}
              </Link>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `mk-nav-drawer-link${isActive ? " is-active" : ""}`}
              >
                {item.label}
              </NavLink>
            )
          )}
          <div className="mk-nav-drawer-actions">
            <button type="button" className="zn-btn-login" onClick={handleLogin}>Login</button>
            <button type="button" className="zn-btn-signup" onClick={handleSignUp}>Sign Up</button>
            <button type="button" className="zn-btn-demo" onClick={handleDemo}>Book a Demo</button>
          </div>
        </div>
      ) : null}
    </nav>
  );
}
